import {
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY,
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_SUCCESS,
  GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE,
  CHECKIN_RESERVATION,
  CHECKIN_RESERVATION_SUCCESS,
  CHECKIN_RESERVATION_FAILURE,
  SET_RES_ID,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_SUCCESS,
  GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE,
  TRY_GET_RESERVATION_BY_LICENCE_PLATE,
  UPDATE_RESERVATION,
  UPDATE_RESERVATION_FAILURE,
  UPDATE_RESERVATION_SUCCESS,
  CLEAR_RESERVATION,
  SET_DRIVER1_BIRTH_DATE,
  GET_RESERVATION_ORIGIN_SUCCESS,
  GET_UI_CONFIG_SUCCESS,
  SET_TOTAL_PAGES_COUNT,
  SET_CURRENT_PAGE,
  SET_APP_STATE,
} from '../constants/actions'
import { Reservation } from '../types/reservation'
import { UiConfig } from '../types/uiConfig'

interface State {
  isLoading: boolean
  error?: string
  reservation?: Reservation
  originReservation?: Reservation
  checkinInfo?: Reservation
  resId?: string
  birthDate: string
  checkinSuccess?: boolean
  uiConfig?: UiConfig
  isDocumentRequires: boolean
  currentPage: number
  totalPagesCount: number
}
const initialState: State = {
  isLoading: false,
  error: '',
  reservation: undefined,
  originReservation: undefined,
  checkinInfo: undefined,
  birthDate: '',
  uiConfig: undefined,
  isDocumentRequires: false,
  currentPage: 1,
  totalPagesCount: 0,
}
const reducer = (state: State = initialState, action: any): State => {
  switch (action.type) {
    case GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY:
      return { ...state, isLoading: true }
    case GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_SUCCESS:
      return {
        ...state,
        reservation: action.payload.reservation,
        isDocumentRequires: action.payload.isDocumentRequires,
        isLoading: false,
      }
    case TRY_GET_RESERVATION_BY_LICENCE_PLATE:
      return { ...state, resId: action.payload, isLoading: false }
    case GET_RESERVATION_BY_NUMBER_AND_DRIVERS_BIRTHDAY_FAILURE:
      return { ...state, error: 'cannot load reservation', isLoading: false }
    case GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE:
      return { ...state, isLoading: true }
    case GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_SUCCESS:
      return {
        ...state,
        reservation: action.payload.reservationWithoutDriversInfo,
        isDocumentRequires: action.payload.isDocumentRequires,
        isLoading: false,
      }
    case GET_RESERVATION_BY_NUMBER_AND_LICENCE_PLATE_FAILURE:
      return { ...state, error: 'cannot load reservation', isLoading: false }
    case CHECKIN_RESERVATION:
      return { ...state, isLoading: true }
    case CHECKIN_RESERVATION_FAILURE:
      return { ...state, error: 'cannot checkin reservation', isLoading: false }
    case CHECKIN_RESERVATION_SUCCESS:
      return { ...state, reservation: action.payload, checkinSuccess: true, isLoading: false }
    case SET_RES_ID:
      return { ...state, resId: action.payload }
    case SET_DRIVER1_BIRTH_DATE:
      return { ...state, birthDate: action.payload }
    case UPDATE_RESERVATION:
      return { ...state, isLoading: true }
    case UPDATE_RESERVATION_FAILURE:
      return { ...state, error: 'cannot update reservation', isLoading: false }
    case UPDATE_RESERVATION_SUCCESS:
      return { ...state, reservation: action.payload, isLoading: false }
    case CLEAR_RESERVATION:
      return { ...initialState }
    case GET_RESERVATION_ORIGIN_SUCCESS:
      return { ...state, originReservation: action.payload }
    case GET_UI_CONFIG_SUCCESS:
      return { ...state, uiConfig: action.payload }
    case SET_TOTAL_PAGES_COUNT:
      return { ...state, totalPagesCount: action.payload }
    case SET_CURRENT_PAGE:
      return { ...state, currentPage: action.payload }
    case SET_APP_STATE:
      if (action.payload.reservation){
        return { ...state, ...action.payload.reservation }
      }
    default:
      return state
  }
}

export default reducer
